<template>
  <v-app id="inspire">
    <v-main>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"             
                flat
                dark
              >
                <v-toolbar-title>Password Change Form</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    v-model="email"
                    label="E-mail"
                    name="email"
                    prepend-icon="mdi-account"
                    type="text"
                  ></v-text-field>

                  <v-text-field
                    v-model="password"
                    label="Password"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                  ></v-text-field>

                  <v-text-field
                    v-model="newPassword"
                    label="New Password"
                    name="newPassword"
                    prepend-icon="mdi-lock"
                    type="password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="change()" color="secondary">Change Password</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import { CHANGE_PASSWORD_MUTATION } from '../../graphql/authenticationQueries.js';

  export default {
    props: {
      source: String,
    },
    data () {
      return {
        email: null,
        password: null,
        newPassword: null,
      }
    },
    apollo: {
      $client: 'authenticationClient'
    },
    methods: {
      async change(){
        const { email, password, newPassword } = this.$data;
        try {
          const result = await this.$apollo.mutate({
            mutation: CHANGE_PASSWORD_MUTATION,
            variables: {
              email: email,
              password: password,
              newPassword: newPassword
            }
          });

          if(result.data.changePassword)
          {
            if (result.data.changePassword == "OK")
            {
              alert(`Successfully changed password for user '${email}'`);
            } else {
              alert(result.data.changePassword);
            }
          }
        } catch (error) {
          alert(`Error trying to change password for user '${email}'`);
        }
      }
    }
  }
</script>